import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AvatarModule } from '@y42/core/avatar';
import { FormatValueConversionModule } from '@y42/core/format-value-conversion';
import { IconModule } from '@y42/core/icon';
import { DateTimeModule } from '@y42/date-time';
import { JobCancellationButtonModule } from '../../job-cancellation-button';
import { JobTriggeredByUserAvatarModule } from '../../job-triggered-by-user-avatar';
import { JobInfoContentComponent } from './job-info-content.component';

@NgModule({
  declarations: [JobInfoContentComponent],
  imports: [
    CommonModule,
    AvatarModule,
    FontAwesomeModule,
    MatButtonModule,
    JobCancellationButtonModule,
    IconModule,
    DateTimeModule,
    JobTriggeredByUserAvatarModule,
    FormatValueConversionModule,
  ],
  exports: [JobInfoContentComponent],
})
export class JobInfoContentModule {}
